import axios from 'axios';

export const getAdvertiserPixels = async id =>
  axios.get(`/advertiser/pixel/?advertiserId=${id}`).then(res => res.data.rows);
